import SearchIcon from "@mui/icons-material/Search";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  FormControl,
  InputAdornment,
  OutlinedInput,
  Modal,
} from "@mui/material";
import { Box } from "@mui/system";

import React, { createContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import CreateableSelectAutoCapitalize from "../../../common/components/FormFields/CreateableSelectAutoCapitalize";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import InputField from "../../../common/components/FormFields/InputField";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../common/components/Toasts/CustomToasts";
import { addDays, format } from "date-fns";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import CheckBoxField from "../../../common/components/FormFields/CheckBoxField";
import { fetchFloor } from "../../../commonServices/miscellaneousServices/MiscServices";
import {
  drugAdminPatientList,
  getDrugGenericNameDropdown,
  getDrugInstructionDropdown,
  getDrugList,
  getDrugNameDropdown,
  getOrderedDrugList,
  getRouteDropdown,
  getdrugFormDropdown,
  saveDrugAdminstratorOrder,
} from "../../services/drugadministratororderservices/DrugAdministratOrorderServices";
import { yupResolver } from "@hookform/resolvers/yup";
import { useLocation } from "react-router-dom";
import * as yup from "yup";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import DatePickerFieldNew from "../../../common/components/FormFields/DatePickerFieldNew";
import { fetchUserActionsByMenuId } from "../../../commonServices/functionalityServices/FunctionalityServices";
import { getFrequencyForDrugOrder } from "../../../nursingStation/services/drugAdministrationChartService/DrugAdministartionChartService";
import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";
import CommonDynamicTablePaginationNew from "../../../common/components/CommonTable/CommonDynamicTablePaginationNew";
import CommonDynamicTableNew from "../../../common/components/CommonTable/CommonDynamicTableNew";
import { CapitalizeStatement } from "../../../common/components/Custom Hooks/CapitalizeStatement";
import { UseCheckConsecutiveCharacters } from "../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const actions = ["assessmentPrint"];
export const GlobalContext = createContext();

export const ModalStyleForHighantiModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "20%",
  overflowY: "auto",
  bgcolor: "background.paper",
  boxShadow: 20,
  p: 2,
};

export default function DrugAdministratorOrder(props) {
  //use form
  const schema = yup.object().shape({
    drugName: yup
      .object()
      .nullable()
      .required("Required")
      .shape({
        value: yup.string().required("Required"),
        label: yup.string().required("Required"),
      }),
    dosage: yup.string().required("Required"),
    // .matches(/^[+1-9]+[0-9]*$/, "Only numbers are allowed"),
    frequency: yup
      .object()
      .nullable()
      .required("Required")
      .shape({
        value: yup.string().required("Required"),
        label: yup.string().required("Required"),
      }),
    // form: yup
    //   .object()
    //   .nullable()
    //   .required("Required")
    //   .shape({
    //     value: yup.string().required("Required"),
    //     label: yup.string().required("Required"),
    //   }),
    durationInDays: yup
      .string()
      .required("Required")
      .matches(/^[+1-9]+[0-9]*$/, "Only numbers are allowed"),
    route: yup
      .object()
      .nullable()
      .required("Required")
      .shape({
        value: yup.string().required("Required"),
        label: yup.string().required("Required"),
      }),
  });

  const defaultValues = {
    search: "",
    drugName: null,
    genericName: null,
    form: null,
    dosage: "",
    onceInWeekDrug: false,
    alternativeDayDrug: false,
    perHourDrug: false,
    frequency: null,
    durationInDays: "",
    quantity: "",
    route: null,
    isOutSideMedication: false,
    instructions: null,
    fromDateFilter: new Date(),
    toDateFilter: new Date(),
    fromDate: new Date(),
    toDate: new Date(),
    durationIn: "Days",
    hours: "",
    isOutsideMedication: false,
    isCultureSent: false,
    cultureReason: "",
  };

  const {
    control,
    watch,
    setValue,
    clearErrors,
    register,
    getValues,
    setError,
    trigger,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues,
  });

  //Local variables
  let freqArray;
  let token = JSON.parse(localStorage.getItem("userInfo"));
  let floorVal = watch("floor");
  let drugNameVal = watch("drugName");
  let drugGenericNameVal = watch("genericName");
  let dosageVal = watch("dosage");
  let onceInWeekDrugVal = watch("onceInWeekDrug");
  let alternativeDayDrugVal = watch("alternativeDayDrug");
  let perHourDrugVal = watch("perHourDrug");
  let durationInDaysVal = watch("durationInDays");
  let quantityVal = watch("quantity");
  let formVal = watch("form");
  let frequencyVal = watch("frequency");
  let routeVal = watch("route");
  let outsideMedicineVal = watch("isOutsideMedication");
  let instructionsVal = watch("instructions");
  let durationInValue = watch("durationIn");
  let fromDateValue = watch("fromDate");
  let toDateValue = watch("toDate");
  let filterFromDate = watch("fromDateFilter");
  let filterToDate = watch("toDateFilter");
  let hoursValue = watch("hours");

  const location = useLocation();

  //state variables
  const [floorOptions, setFloorOptions] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [searchPatient, setSearchPatient] = useState(null);
  const [rowData, setRowData] = useState(null);
  const [count, setCount] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [orderedDrugList, setOrderedDrugList] = useState([]);
  const [drugList, setDrugList] = useState([]);
  const [genericName, setGenericName] = useState([]);
  const [formList, setFormList] = useState([]);
  const [routeOptions, setRouteOptions] = useState([]);
  const [drugNameOptions, setDrugNameOptions] = useState([]);
  const [drugInstructionsOptions, setDrugInstructionsOptions] = useState([]);
  const [drugFrequencyOptions, setDrugFrequencyOptions] = useState([]);
  const [orderDrug, setOrderDrug] = useState([]);
  const [finalData, setFinalData] = useState(null);
  // for calculate date
  const [userActions, setUserActions] = useState([]);
  const [privilege, setPrivilege] = useState("");
  const [openConfiramtionModal, setOpenConfiramtionModal] = useState(false);
  const [frequency, setFrequency] = useState(null);
  const [openLoader, setOpenLoader] = useState(false);
  const [openHighantiModal, setOpenHighantiModal] = useState(false);
  const [capturehigherAntiReason, setCaptureHigherAntiReason] = useState(false);
  const [openRateConfirmModal, setOpenRateConfirmModal] = useState(false);

  console.log("orderDrug321", orderDrug);

  // default params
  let defaultParams = {
    admissionId: rowData?.AdmissionId,
    fromDate: filterFromDate,
    page: page,
    size: rowsPerPage,
    toDate: filterToDate,
  };

  //get options for Generic name dropdown
  function getGenericNameDropdownList(searchGenericName) {
    if (
      searchGenericName &&
      searchGenericName !== undefined &&
      UseCheckConsecutiveCharacters(searchGenericName)
    ) {
      getDrugGenericNameDropdown(searchGenericName)
        .then((response) => response.data)
        .then((res) => {
          setGenericName(res.result);
        });
    }
  }

  const handleSearchDrugName = (searchString) => {
    if (searchString !== "" && UseCheckConsecutiveCharacters(searchString)) {
      getDrugNameDropdown(searchString)
        .then((response) => {
          setDrugNameOptions(response.data.result);
        })
        .catch((error) => {
          console.log("error", error);
        });
    } else {
      setDrugNameOptions([]);
    }
  };

  const searchPatientList = () => {
    let Obj = {
      floorId: floorVal ? floorVal.id : 0,
      searchString: searchPatient,
    };
    drugAdminPatientList(Obj)
      .then((response) => response.data)
      .then((res) => {
        setSearchResult(res.result);
      });
  };

  function getPatientList() {
    let defaultObj = {
      searchString: "",
      floorId: floorVal?.id,
    };
    drugAdminPatientList(defaultObj)
      .then((response) => response.data)
      .then((res) => {
        setSearchResult(res.result);
      });
  }

  function handleSelectedRow(row) {
    setRowData(row);
  }

  const orderedDrugLists = () => {
    if (rowData !== null) {
      getOrderedDrugList(defaultParams)
        .then((response) => {
          setCount(response.data.count);
          return response.data;
        })
        .then((res) => {
          setOrderedDrugList(res.result);
        });
    }
  };

  //get PrescriptionId id from table and set
  function handleOrderDrugListSelectedRow(row) {
    drugListing(row.PrescriptionId);
  }

  //drug listing
  function drugListing(prescription) {
    getDrugList(prescription)
      .then((response) => response.data)
      .then((res) => {
        setDrugList(res.result);
      });
  }

  // add dugs into table
  function orderDrugs() {
    let isAdminValue = 0;
    if (onceInWeekDrugVal === true) {
      isAdminValue = 1;
    } else if (alternativeDayDrugVal === true) {
      isAdminValue = 2;
    } else if (perHourDrugVal === true) {
      isAdminValue = 3;
    }
    let orderDrugObj = {};
    const fromDt = format(fromDateValue, "yyyy-MM-dd'T'HH:mm:ss");
    if (
      drugNameVal !== null &&
      routeVal !== null &&
      frequencyVal !== null &&
      dosageVal !== "" &&
      durationInDaysVal !== "" &&
      quantityVal !== ""
    ) {
      const toDt = format(toDateValue, "yyyy-MM-dd'T'HH:mm:ss");

      orderDrugObj["Drug Name"] =
        drugNameVal && drugNameVal.label.toUpperCase();
      orderDrugObj.Highanti = drugNameVal.Highanti === true ? true : false;
      orderDrugObj.drugId = drugNameVal && drugNameVal.id ? drugNameVal.id : 0;
      orderDrugObj["Drug Generic Name"] =
        drugGenericNameVal !== null
          ? CapitalizeStatement(drugGenericNameVal.label)
          : "";
      orderDrugObj.genericId =
        drugGenericNameVal !== null ? drugGenericNameVal.id : 0;
      orderDrugObj["Form Name"] =
        formVal !== null ? CapitalizeStatement(formVal.label) : "";
      orderDrugObj.formId = formVal !== null ? formVal.id : 0;
      orderDrugObj["Dose"] = dosageVal;
      orderDrugObj.adminAs = isAdminValue;
      orderDrugObj.Frequency =
        frequencyVal && CapitalizeStatement(frequencyVal.label);
      orderDrugObj.frequencyId = frequencyVal && frequencyVal.id;
      orderDrugObj["Duration In Days"] = durationInDaysVal;
      orderDrugObj.Duration = durationInDaysVal;
      orderDrugObj.Quantity = quantityVal;
      orderDrugObj.Route = routeVal && CapitalizeStatement(routeVal.label);
      orderDrugObj.routeId = routeVal && routeVal.Id;
      orderDrugObj["Is Outside Medicine"] = outsideMedicineVal;
      orderDrugObj.Instruction =
        instructionsVal && CapitalizeStatement(instructionsVal.label);
      orderDrugObj.instructionId = instructionsVal && instructionsVal.Id;
      orderDrugObj["Start Date"] = fromDt;
      orderDrugObj["Start Time"] = fromDt;
      orderDrugObj["End Date"] = toDt;
      orderDrugObj["End Time"] = toDt;
      orderDrugObj.printDrugName = 0;
      orderDrugObj.pendingQty = 0;
      orderDrugObj.canceledBy = 0;
      orderDrugObj.isNew = true;
      orderDrugObj.isMarkForDrugAdmin = true;
      orderDrugObj.isInstructionNew = true;
      orderDrugObj.isFinalizeForIndent = true;
      orderDrugObj["Once In Week"] = onceInWeekDrugVal;
      orderDrugObj["Alternative Day"] = alternativeDayDrugVal;
      orderDrugObj["Per Hour"] = perHourDrugVal;
      orderDrugObj.isCultureSent = getValues("isCultureSent");
      orderDrugObj.cultureReason = getValues("cultureReason");
      orderDrugObj.Hours = perHourDrugVal === true ? Number(hoursValue) : 0;
      orderDrugObj.acknowledge = drugNameVal?.MRP >= 5000 ? true : false;
      let temp = [...orderDrug];
      temp.push(orderDrugObj);
      setOrderDrug(temp);
      reset(defaultValues);
      setValue("drugName", null);
      setDrugNameOptions([]);
      setTimeout(() => {
        const searchMedicineInput = document.querySelector(".drugName-0 input");
        if (searchMedicineInput) {
          searchMedicineInput.focus();
        }
      }, 100);
    } else {
      trigger();
    }
  }

  function postDrugAdministration(obj) {
    saveDrugAdminstratorOrder(obj)
      .then((response) => response.data)
      .then((res) => {
        successAlert(res.message);
        setFinalData({});
        // orderedDrugLists();
        setOrderDrug([]);
        reset(defaultValues);
        setOpenLoader(false);
      })
      .catch((error) => {
        errorAlert(error.message);
        setOpenConfiramtionModal(false);
        setOpenLoader(false);
      });
  }
  //
  function addRecord() {
    setOpenConfiramtionModal(false);
    setOpenLoader(true);
    postDrugAdministration(finalData);
  }

  //
  function onSubmitDataHandler(data) {
    let useInfoObj = JSON.parse(localStorage.getItem("userInfo"));
    if (orderDrug.length > 0) {
      let tempArr = [];
      for (let orderDrugObj of orderDrug) {
        let tempObj = {
          drugName: orderDrugObj["Drug Name"],
          drugId: orderDrugObj.drugId,
          highAnti: orderDrugObj.Highanti === true ? true : false,
          drugGenericName: orderDrugObj["Drug Generic Name"],
          genericId: orderDrugObj.genericId,
          formname: orderDrugObj["Form Name"],
          formId: orderDrugObj.formId,
          dose: orderDrugObj.Dose,
          adminAs: orderDrugObj.adminAs,
          frequency: orderDrugObj.Frequency,
          frequencyId: orderDrugObj.frequencyId,
          formId: orderDrugObj.formId,
          durationInDays: orderDrugObj["Duration In Days"],
          duration: orderDrugObj.Duration,
          quantity: orderDrugObj.Quantity,
          route: orderDrugObj.Route,
          routeId: orderDrugObj.routeId,
          isOutsideMedication: orderDrugObj["Is Outside Medicine"],
          instruction: orderDrugObj.Instruction,
          instructionId: orderDrugObj.instructionId,
          startDate: orderDrugObj["Start Date"],
          startTime: orderDrugObj["Start Time"],
          endDate: orderDrugObj["End Date"],
          endTime: orderDrugObj["End Time"],
          printDrugName: orderDrugObj.printDrugName,
          pendingQty: orderDrugObj.pendingQty,
          canceledBy: orderDrugObj.canceledBy,
          isNew: orderDrugObj.isNew,
          isMarkForDrugAdmin: orderDrugObj.isMarkForDrugAdmin,
          isInstructionNew: orderDrugObj.isInstructionNew,
          isFinalizeForIndent: orderDrugObj.isFinalizeForIndent,
          onceInWeek: orderDrugObj["Once In Week"],
          alternativeDay: orderDrugObj["Alternative Drug"],
          isPerHour: orderDrugObj["Per Hour"],
          hours: orderDrugObj.Hours,
          isCultureSent: orderDrugObj.isCultureSent,
          cultureReason: orderDrugObj.cultureReason,
          acknowledge: orderDrugObj?.acknowledge,
        };
        tempArr.push(tempObj);
      }
      let postObj = {
        addedBy: useInfoObj.userId,
        admissionId:
          rowData.AdmissionId !== undefined
            ? rowData.AdmissionId
            : rowData.admissionId,
        opdIpd: 1,
        prescriptionDetailsDtoList: tempArr,
        menuId:
          props.menuId !== undefined ? props.menuId : location.state.menuId,
        privilege: "Create",
      };
      setFinalData(postObj);
      setOpenConfiramtionModal(true);
    } else {
      warningAlert("Please Add Drug First...!");
    }
  }

  //get order drug list
  useEffect(() => {
    orderedDrugLists();
  }, [rowData, filterFromDate, filterToDate]);

  //empty order drug and drug list based on patient row changes
  useEffect(() => {
    setOrderDrug([]);
    setDrugList([]);
  }, [rowData]);

  // patientList
  useEffect(() => {
    if (searchPatient !== null && props.patientInfo === undefined) {
      searchPatientList();
    } else {
      getPatientList();
    }
  }, [searchPatient, floorVal]);

  // frequency options
  useEffect(() => {
    let isAdminValue = 0;
    if (onceInWeekDrugVal === true) {
      isAdminValue = 1;
    } else if (alternativeDayDrugVal === true) {
      isAdminValue = 2;
    } else if (perHourDrugVal === true) {
      isAdminValue = 3;
    }
    //getFrequency dropdown serivce
    getFrequencyForDrugOrder(isAdminValue)
      .then((response) => response.data)
      .then((res) => {
        setDrugFrequencyOptions(res.result);
      });
  }, [onceInWeekDrugVal, alternativeDayDrugVal, perHourDrugVal]);

  // other apis
  useEffect(() => {
    // getForm dropdown list
    getdrugFormDropdown()
      .then((response) => response.data)
      .then((res) => {
        setFormList(res.result);
      });
    //getRoute dropdownlist
    getRouteDropdown()
      .then((response) => response.data)
      .then((res) => {
        setRouteOptions(res.result);
      });
    //getInstruction dropdown service
    getDrugInstructionDropdown()
      .then((response) => response.data)
      .then((res) => {
        setDrugInstructionsOptions(res.result);
      });
    //get options for drug name dropdown

    fetchFloor()
      .then((response) => response.data)
      .then((res) => {
        setFloorOptions(res.result);
      });
    if (token.floor !== null) {
      setValue("floor", {
        id: token.floorId,
        value: token.floor,
        label: token.floor,
      });
    }
  }, []);

  // get user actios
  useEffect(() => {
    location?.state?.menuId &&
      fetchUserActionsByMenuId(location?.state?.menuId)
        .then((response) => response.data)
        .then((res) => {
          setUserActions(res.result);
        });
  }, []);

  //set frequency value
  useEffect(() => {
    if (frequencyVal && frequencyVal !== null) {
      freqArray = frequencyVal.label.split("-");
      setFrequency(freqArray);
    }
  }, [frequencyVal, durationInDaysVal]);

  // calculate quantity using frequency dropdown value

  useEffect(() => {
    let frequencyCountValue = 0;
    if (frequency && Array.isArray(frequency)) {
      const frequencyMap = {
        "1/2": 0.5,
        "½": 0.5,
        "¼": 0.25,
        1: 1,
        "1½": 1.5,
        "1/8": 0.125,
        2: 2,
        "2½": 2.5,
        3: 3,
        "3½": 3.5,
        4: 4,
        "4½": 4.5,
        STAT: 1,
        SOS: 1,
        "Stat/sos": 1,
        "Per Hour": 1,
        bolus: 1,
        9: 9,
      };

      frequency.forEach((element) => {
        const value = element.trim();
        frequencyCountValue += frequencyMap[value] || 0;
      });
    }

    let quantityCount = 0;
    const durationDays = Number(durationInDaysVal);

    if (durationInValue === "Week") {
      quantityCount = durationDays * 1 * frequencyCountValue;
    } else if (durationInValue === "Days") {
      quantityCount = durationDays * frequencyCountValue;
    }

    const totalQuantity = Math.ceil(quantityCount);

    try {
      setValue("quantity", !isNaN(totalQuantity) ? totalQuantity : 0, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
      trigger("quantity");
    } catch (error) {
      console.error("Error setting quantity value:", error);
    }
  }, [
    durationInDaysVal,
    durationInValue,
    frequency,
    frequencyVal,
    alternativeDayDrugVal,
    onceInWeekDrugVal,
    perHourDrugVal,
    hoursValue,
  ]);

  useEffect(() => {
    // let quantityCount;
    let frequencyObject;
    if (perHourDrugVal === true) {
      frequencyObject = drugFrequencyOptions.find(
        (list) => list.label.toLowerCase() === "per hour"
      );
      setValue("frequency", frequencyObject);
      setValue("hours", 1);
    } else if (perHourDrugVal === false) {
      setValue("frequency", null);
      setValue("hours", "");
      setValue("immediate", false);
      setValue("quantity", "");
      clearErrors("quantity");
      clearErrors("hours");
      if (frequencyVal && frequencyVal.label.toLowerCase() === "per hour") {
        setValue("frequency", null);
      }
      setValue("hours", "");
      clearErrors("quantity");
    }
  }, [perHourDrugVal]);

  // calculate to date
  useEffect(() => {
    if (durationInValue !== null && durationInDaysVal !== "") {
      const validFromDateValue =
        fromDateValue instanceof Date && !isNaN(fromDateValue)
          ? fromDateValue
          : new Date();

      if (alternativeDayDrugVal === true) {
        const parsedValue = Number(durationInDaysVal) * 2 - 2;
        const updatedDate = addDays(validFromDateValue, parsedValue);
        setValue("toDate", updatedDate);
      } else if (durationInValue === "Days") {
        const parsedValue = Number(durationInDaysVal) - 2;
        const updatedDate = addDays(validFromDateValue, parsedValue + 1);
        setValue("toDate", updatedDate);
      } else if (durationInValue === "Week") {
        const parsedValue = Number(durationInDaysVal) * 7;
        const updatedDate = addDays(validFromDateValue, parsedValue);
        setValue("toDate", updatedDate);
      }
    }
  }, [
    fromDateValue,
    durationInDaysVal,
    durationInValue,
    alternativeDayDrugVal,
    perHourDrugVal,
  ]);

  //new useEffect
  useEffect(() => {
    const now = new Date();
    const dayEndTime = new Date(now);
    dayEndTime.setHours(23, 59, 59, 999);

    const timeleft = dayEndTime - now;
    const remainingHoursToday = Math.floor(timeleft / (1000 * 60 * 60));
    const remainingMinutesToday = Math.floor(
      (timeleft % (1000 * 60 * 60)) / (1000 * 60)
    );
    const getPerHourDrug = watch("perHourDrug");
    const getHour = watch("hours");
    const getDuration = watch("durationInDays");

    let forQuantity;

    if (getPerHourDrug === true) {
      if (getDuration === "") {
        forQuantity = remainingHoursToday / getHour;
      } else {
        const totalDurationHours =
          getDuration * 24 - (24 - remainingHoursToday);
        forQuantity = totalDurationHours / getHour;
      }
      if (Number(remainingMinutesToday) > 30) {
        setValue("quantity", Math.max(1, Math.floor(forQuantity + 1)));
      } else {
        setValue("quantity", Math.max(1, Math.floor(forQuantity)));
      }
    }

    const frequencyVal = watch("frequency");
    if (frequencyVal?.label === "STAT" || frequencyVal?.label === "SOS") {
      setValue("quantity", 1);
    }
  }, [durationInDaysVal, hoursValue, frequencyVal]);

  useEffect(() => {
    if (
      frequencyVal?.label === "SOS" ||
      frequencyVal?.label === "STAT" ||
      frequencyVal?.label === "Stat/sos"
    ) {
      setValue("durationInDays", "1");
    }
  }, [frequencyVal]);

  useEffect(() => {
    setTimeout(() => {
      const searchMedicineInput = document.querySelector(".drugName-0 input");
      if (searchMedicineInput) {
        searchMedicineInput.focus();
      }
    }, 100);
  }, []);

  /// clinical care chart
  useEffect(() => {
    if (props.patientInfo !== undefined) {
      setRowData(props.patientInfo);
    }
    if (props.selectedPatient) {
      setRowData(props?.selectedPatient);
    }
  }, [props]);

  console.log("drugNameVal321", drugNameVal);

  return (
    <>
      <div className="mt-14  w-full">
        <h1 className="text-center text-black font-bold text-lg py-2">
          Drug Administrator Order
        </h1>
        <div className="lg:flex lg:space-x-3 w-full">
          {props.patientInfo === undefined && (
            <div className="lg:w-[40%] xl:w-[25%]  md:w-[100%] 2xl:w-[24rem]">
              <div className="md:flex lg:grid-cols-1 lg:grid gap-2 w-full my-2 lg:my-0">
                <div className=" md:w-full md:grid-cols-1 grid lg:grid-cols-1 gap-2 md:col-span-3 lg:col-span-1">
                  <div className="md:w-full z-50">
                    <DropdownField
                      control={control}
                      name="floor"
                      placeholder="Floor"
                      label="Floor"
                      dataArray={floorOptions}
                      isSearchable={false}
                      isClearable={true}
                    />
                  </div>
                </div>
                {/* searchable */}

                <FormControl>
                  <OutlinedInput
                    size="small"
                    fullWidth
                    {...register("search")}
                    name="search"
                    sx={{
                      "& .MuiOutlinedInput-input::placeholder": {
                        fontSize: "14px",
                      },
                    }}
                    onChange={(e) => {
                      setSearchPatient(e.target.value);
                    }}
                    className="bg-white h-9 text-[14px]"
                    placeholder="Search by Patient Name / Mr No."
                    endAdornment={
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </div>
              <div className="mt-1 h-auto">
                <>
                  <h1 className="font-bold ">Patient List</h1>
                  {searchResult.length > 0 ? (
                    <>
                      <CommonDynamicTableNew
                        dataResult={searchResult}
                        handleSelectedRow={handleSelectedRow}
                        removeHeaders={["PatientId", "AdmissionId"]}
                        tableClass={
                          "rounded h-[300px] lg:h-[530px] xl:h-[484px]  2xl:h-[720px]"
                        }
                      />
                    </>
                  ) : (
                    <div className="pt-10 text-center">
                      <p>No Record Found....</p>
                    </div>
                  )}
                </>
              </div>

              {/* do not show "No Records found" when data is loading ; AND when the data has arrived successfully*/}
            </div>
          )}

          <div
            className={
              props.patientInfo !== undefined
                ? "w-full  overflow-hidden  "
                : "overflow-hidden lg:border-l-2 w-full"
            }
          >
            <div className="flex  mx-2 gap-2">
              <fieldset className=" mx-auto border w-full rounded my-1 ">
                {/* <legend className="ml-6 my-2 rounded-"></legend> */}
                <div className="bg-gray-100 lg:grid lg:grid-cols-3 md:grid md:grid-cols-2 gap-1 py-1 px-3 text-xs 2xl:text-sm">
                  <div className="flex  items-center  gap-2 w-full col-span-2 font-semibold  py-1">
                    <span className="w-28 font-semibold"> Patient Name</span>
                    <div className="flex space-x-2 items-center">
                      <span>:</span>
                      <span className="text-gray-700 font-normal">
                        {rowData?.["Patient Name"] || rowData?.PatientName}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-enter gap-2 w-full font-semibold py-1">
                    <span className="w-16 font-semibold"> MR No. </span>
                    <div className="flex space-x-2 items-center">
                      <span>:</span>
                      <span className="text-gray-700 font-normal">
                        {rowData?.MRNo}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 w-full font-semibold py-1">
                    <span className="w-28 font-semibold">Doctor Name</span>
                    <div className="flex space-x-2 items-center">
                      <span>:</span>
                      <span className="text-gray-700 font-normal">
                        {rowData?.["Doctor Name"] || rowData?.DoctorName}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 w-full font-semibold py-1 ">
                    <span className="w-16 font-semibold">Bed No</span>
                    <div className="flex space-x-2 items-center">
                      <span>:</span>
                      <span className="text-gray-700 font-normal">
                        {rowData?.BedNo || rowData?.["Bed No"]}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 w-full font-semibold py-1 ">
                    <span className="w-16 font-semibold">Age</span>
                    <div className="flex space-x-2 items-center">
                      <span>:</span>
                      <span className="text-gray-700 font-normal">
                        {rowData?.Age || rowData?.["Age"]}
                      </span>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            {rowData !== null ? (
              <div className="px-2">
                <div className="w-full py-2">
                  <div className="flex justify-between items-center gap-2">
                    <h2 className="font-semibold space-x-2 px-2 rounded bg-blue-200 shadow-sm w-[50%]">
                      <span className="">Diagnosis :</span>
                      {/* <span className="font-normal">{selectedPatient?.Diagnosis}</span> */}
                    </h2>
                    <h2 className="font-semibold px-2 rounded bg-red-200 shadow-sm  space-x-2 w-[50%]">
                      <span>Allergic : </span>
                      {/* <span className="font-normal">{selectedPatient?.Allergies}</span> */}
                    </h2>
                  </div>
                </div>
                <Accordion
                  elevation={2}
                  sx={{
                    border: "1px solid lightgray",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel5bh-content"
                    id="panel5bh-header"
                    sx={{
                      "&.Mui-expanded": {
                        marginBottom: "0.3rem",
                        minHeight: "40px",
                      },
                      "& .MuiAccordionSummary-content.Mui-expanded": {
                        margin: 0,
                      },
                      backgroundColor: "#CCE4FB",
                    }}
                  >
                    <p className="font-bold tracking-wide text-sm font-Poppins">
                      Ordered Drug
                    </p>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="grid gap-2 px-2">
                      <div className="grid grid-cols-4 gap-2 items-center mt-2">
                        <DatePickerFieldNew
                          control={control}
                          name="fromDateFilter"
                          label="From Date"
                          disablePast={false}
                          inputFormat="dd-MM-yyyy"
                        />
                        <DatePickerFieldNew
                          control={control}
                          name="toDateFilter"
                          label="To Date"
                          inputFormat="dd-MM-yyyy"
                        />
                      </div>
                      <div className="flex space-x-1 w-full">
                        <div className=" w-full">
                          <h2 className="font-bold">Ordered Drug List</h2>

                          {orderedDrugList.length > 0 ? (
                            <>
                              <CommonDynamicTablePaginationNew
                                dataResult={orderedDrugList}
                                page={page}
                                setPage={setPage}
                                rowsPerPage={rowsPerPage}
                                setRowsPerPage={setRowsPerPage}
                                setDataResult={setOrderedDrugList}
                                actions={actions}
                                count={count}
                                handleSelectedRow={
                                  handleOrderDrugListSelectedRow
                                }
                                tableClass={"rounded lg:h-48"}
                                removeHeaders={["PrescriptionId", "DoctorId"]}
                                defaultParams={defaultParams}
                                tableApiFunc={getOrderedDrugList}
                                populateTable={orderedDrugLists}
                              />
                            </>
                          ) : (
                            <h3 className="text-center font-bold text-gray-600 py-28">
                              No Record Found
                              <span className="tracking-widest animate-pulse">
                                ...
                              </span>
                            </h3>
                          )}
                        </div>
                        <Divider
                          color="#1e3a8a"
                          orientation="vertical"
                          flexItem
                          sx={{ width: 2 }}
                        />
                        <div className="w-full">
                          <h2 className="font-bold">Drug List</h2>
                          {drugList.length > 0 ? (
                            <div className="">
                              <CommonDynamicTableNew
                                dataResult={drugList}
                                highlightRow={false}
                                // handleSelectedRow={handleOrderDrugListSelectedRow}
                                tableClass={"rounded lg:h-[232px]"}
                                removeHeaders={["PrescriptionId", "Id", "Code"]}
                              />
                            </div>
                          ) : (
                            <h3 className="text-center font-bold text-gray-600 py-28">
                              No Record Found
                              <span className="tracking-widest animate-pulse">
                                ...
                              </span>
                            </h3>
                          )}
                        </div>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>

                <Divider color="#1e3a8a" sx={{ height: 2, marginTop: "8px" }} />
                <form>
                  <div className="px-2 mt-2">
                    <span className="font-bold">Drug Order</span>

                    {orderDrug && orderDrug.length > 0 ? (
                      <CommonDynamicTableNew
                        dataResult={orderDrug}
                        actions={actions}
                        removeHeaders={[
                          "drugId",
                          "formId",
                          "frequencyId",
                          "genericId",
                          "routeId",
                          "instructionId",
                          "startTime",
                          "endTime",
                          "printDrugName",
                          "pendingQty",
                          "isNew",
                          "isMarkForDrugAdmin",
                          "canceledBy",
                          "isInstructionNew",
                          "isFinalizeForIndent",
                          "adminAs",
                          "Highanti",
                          "isCultureSent",
                        ]}
                        highlightRow={false}
                      />
                    ) : (
                      <div className="text-center items-center py-14">
                        No Record Found...
                      </div>
                    )}
                    {orderDrug && orderDrug.length > 0 ? (
                      <div className="flex gap-2 justify-end pt-2">
                        {userActions &&
                          userActions.map((obj) => (
                            <>
                              {!obj.isAction && obj.action === "Create" ? (
                                <>
                                  <CommonButton
                                    type="button"
                                    className="border border-customRed text-customRed"
                                    label="Reset"
                                    onClick={() => {
                                      reset(defaultValues);
                                      setOrderDrug([]);
                                    }}
                                  />
                                  <CommonButton
                                    type="button"
                                    className="bg-customGreen text-white"
                                    label="Save"
                                    onClick={() => {
                                      setPrivilege(obj.action);
                                      onSubmitDataHandler();
                                    }}
                                  />
                                </>
                              ) : null}
                            </>
                          ))}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="px-2">
                    <fieldset className=" mx-auto border w-full rounded my-1">
                      <legend className="ml-6 my-2 rounded  font-bold">
                        Order Drug
                      </legend>

                      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 p-2">
                        <div className={`drugName-${0} w-full`}>
                          <CreateableSelectAutoCapitalize
                            control={control}
                            className={`drugName-${0} w-full`}
                            error={errors.drugName}
                            name="drugName"
                            placeholder="Drug Name*"
                            showSearch={true}
                            dataArray={drugNameOptions}
                            isSearchable={false}
                            onInputChange={handleSearchDrugName}
                            inputRef={{
                              ...register("drugName", {
                                onChange: (e) => {
                                  if (e.target.value !== null) {
                                    if (e?.target?.value?.Highanti === true) {
                                      setOpenHighantiModal(true);
                                    }
                                    let genericNameObj = {
                                      id: e.target.value.genericId,
                                      value: e.target.value.genericName,
                                      label: e.target.value.genericName,
                                    };
                                    const dosageInput =
                                      document.getElementById(`dosage`);
                                    dosageInput?.focus();
                                    let formObj = {
                                      id: e.target.value.formId,
                                      value: e.target.value.form,
                                      label: e.target.value.form,
                                    };
                                    if (
                                      e.target.value.genericId !== null &&
                                      e.target.value.genericId !== undefined
                                    ) {
                                      setValue("genericName", genericNameObj);
                                      clearErrors(["genericName"]);
                                    }
                                    if (
                                      e.target.value.formId !== null &&
                                      e.target.value.formId !== undefined
                                    ) {
                                      setValue("form", formObj);
                                      clearErrors(["form"]);
                                    }
                                  } else {
                                    setValue("genericName", null);
                                    setValue("form", null);
                                  }

                                  if (e?.target?.value?.MRP >= 5000) {
                                    setOpenRateConfirmModal(true);
                                  }
                                },
                              }),
                            }}
                          />
                        </div>
                        <div className="w-full">
                          <InputField
                            id={"dosage"}
                            name="dosage"
                            variant="outlined"
                            label="Dosage*"
                            error={errors.dosage}
                            control={control}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                const frequencyFocus = document.querySelector(
                                  `.frequency-${2} input`
                                );
                                if (frequencyFocus) {
                                  frequencyFocus.focus();
                                }
                              }
                            }}
                            // type="number"
                          />
                        </div>
                        <div className={`frequency-${2} w-full`}>
                          <DropdownField
                            className={`frequency-${2}`}
                            control={control}
                            error={errors.frequency}
                            isDisabled={perHourDrugVal}
                            name="frequency"
                            placeholder="Frequency*"
                            dataArray={drugFrequencyOptions}
                            isSearchable={false}
                            menuPlacement={"top"}
                            inputRef={{
                              ...register("frequency", {
                                onChange: (e) => {
                                  if (e.target.value !== null) {
                                    const routeFocus = document.querySelector(
                                      `.route-${3} input`
                                    );
                                    if (routeFocus) {
                                      routeFocus.focus();
                                    }
                                  }
                                },
                              }),
                            }}
                          />
                        </div>

                        <div className={`route-${3} w-full`}>
                          <SearchDropdown
                            control={control}
                            name="route"
                            placeholder="Route*"
                            dataArray={routeOptions}
                            isSearchable={true}
                            menuPlacement={"top"}
                            handleInputChange={(e) => {
                              console.log("", e);
                            }}
                            inputRef={{
                              ...register("route", {
                                onChange: (e) => {
                                  if (e.target.value !== null) {
                                    const durationIndaysFocus =
                                      document.getElementById(`durationInDays`);
                                    if (durationIndaysFocus) {
                                      durationIndaysFocus.focus();
                                    }
                                  }
                                },
                              }),
                            }}
                          />
                        </div>
                        <div className=" w-full flex space-x-2">
                          <div className="w-9/12">
                            <InputField
                              id={"durationInDays"}
                              name="durationInDays"
                              variant="outlined"
                              type="number"
                              label="Duration*"
                              error={errors.durationInDays}
                              control={control}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  const instructionsFocus =
                                    document.querySelector(
                                      `.instructions-${4} input`
                                    );
                                  if (instructionsFocus) {
                                    instructionsFocus.focus();
                                  }
                                }
                              }}
                            />
                          </div>
                          <div className="w-full">
                            <InputField
                              control={control}
                              name="durationIn"
                              label="Dusration In"
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div className={`instructions-${4} w-full`}>
                          <CreateableSelectAutoCapitalize
                            className={`instructions-${4}`}
                            control={control}
                            name="instructions"
                            placeholder="Instructions"
                            dataArray={drugInstructionsOptions}
                            isSearchable={false}
                            menuPlacement={"top"}
                            inputRef={{
                              ...register("instructions", {
                                onChange: (e) => {
                                  if (drugGenericNameVal === null) {
                                    const genericNameFocus =
                                      document.querySelector(
                                        `.genericName-${5} input`
                                      );
                                    if (genericNameFocus) {
                                      genericNameFocus.focus();
                                    }
                                  } else if (formVal === null) {
                                    const itemFormFocus =
                                      document.querySelector(
                                        `.form-${6} input`
                                      );
                                    if (itemFormFocus) {
                                      itemFormFocus.focus();
                                    }
                                  } else if (perHourDrugVal === true) {
                                    const hoursFocus =
                                      document.getElementById(`hours`);
                                    if (hoursFocus) {
                                      hoursFocus.focus();
                                    }
                                  } else {
                                    const quntityFocus =
                                      document.getElementById(`quantity`);
                                    if (quntityFocus) {
                                      quntityFocus.focus();
                                    }
                                  }
                                },
                              }),
                            }}
                          />
                        </div>
                        <div className={`genericName-${5} w-full`}>
                          <SearchDropdown
                            control={control}
                            name="genericName"
                            placeholder="Generic Name"
                            label="Generic Name"
                            isSearchable={true}
                            searchIcon={true}
                            isClearable={true}
                            dataArray={genericName}
                            handleInputChange={getGenericNameDropdownList}
                            inputRef={{
                              ...register("genericName", {
                                onChange: (e) => {
                                  if (e.target.value !== null) {
                                    const itemFormFocus =
                                      document.querySelector(
                                        `.form-${6} input`
                                      );
                                    if (itemFormFocus) {
                                      itemFormFocus.focus();
                                    }
                                  }
                                },
                              }),
                            }}
                          />
                        </div>

                        <div className={`form-${6} w-full`}>
                          <SearchDropdown
                            className={`form-${6} w-full`}
                            control={control}
                            name="form"
                            placeholder="Form"
                            dataArray={formList}
                            isSearchable={false}
                            menuPlacement={"top"}
                            handleInputChange={(e) => {}}
                            inputRef={{
                              ...register("form", {
                                onChange: (e) => {
                                  if (e.target.value !== null) {
                                    const quantityFocus =
                                      document.getElementById(`quantity`);
                                    if (quantityFocus) {
                                      quantityFocus.focus();
                                    }
                                  }
                                },
                              }),
                            }}
                          />
                        </div>

                        <div>
                          <fieldset
                            onChange={(e) => {
                              if (e.target.checked === true) {
                                setValue("onceInWeekDrug", true);
                                setValue("durationIn", "Week");
                              } else if (e.target.checked === false) {
                                setValue("onceInWeekDrug", false);
                                setValue("durationIn", "Days");
                              }
                              setValue("alternativeDayDrug", false);
                              setValue("perHourDrug", false);
                            }}
                          >
                            <CheckBoxField
                              control={control}
                              name="onceInWeekDrug"
                              label="Once In Week Drug"
                              placeholder="Once In Week Drug"
                            />
                          </fieldset>
                        </div>
                        <div className="w-full">
                          <fieldset
                            onChange={(e) => {
                              if (e.target.checked === true) {
                                setValue("alternativeDayDrug", true);
                                setValue("durationIn", "Days");
                              } else if (e.target.checked === false) {
                                setValue("alternativeDayDrug", false);
                                setValue("durationIn", "Days");
                              }
                              setValue("onceInWeekDrug", false);
                              setValue("perHourDrug", false);
                            }}
                          >
                            <CheckBoxField
                              control={control}
                              name="alternativeDayDrug"
                              label="Alternative Day Drug"
                              placeholder="Alternative Day Drug"
                            />
                          </fieldset>
                        </div>
                        {/* Checkbox component */}
                        <div className="w-full flex space-x-2 items-center">
                          <fieldset
                            onChange={(e) => {
                              if (e.target.checked === true) {
                                setValue("perHourDrug", true);
                                setValue("durationIn", "Days");
                              } else if (e.target.checked === false) {
                                setValue("perHourDrug", false);
                                setValue("durationIn", "Days");
                              }
                              setValue("onceInWeekDrug", false);
                              setValue("alternativeDayDrug", false);
                            }}
                          >
                            <CheckBoxField
                              control={control}
                              name="perHourDrug"
                              label="Per Hour Drug"
                              placeholder="Per Hour Drug"
                            />
                          </fieldset>

                          <div>
                            {perHourDrugVal === true ? (
                              <div className="w-full flex space-x-2 items-center">
                                <InputField
                                  control={control}
                                  id={"hours"}
                                  type="number"
                                  name="hours"
                                  label="Hour"
                                  error={errors.hours}
                                  inputRef={{
                                    ...register("hours", {
                                      onChange: (e) => {
                                        if (e.target.value > 24) {
                                          setValue("hours", "24");
                                        } else if (e.target.value === "") {
                                          setValue("quantity", "");
                                        }
                                      },
                                    }),
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                    }
                                  }}
                                />
                              </div>
                            ) : null}
                          </div>
                        </div>

                        <div className="w-full">
                          <InputField
                            id={"quantity"}
                            name="quantity"
                            type="number"
                            variant="outlined"
                            label="Quantity*"
                            control={control}
                          />
                        </div>

                        <div>
                          <CheckBoxField
                            control={control}
                            name="isOutsideMedication"
                            label="Is Outside Medication"
                            placeholder="Is Outside Medication"
                          />
                        </div>

                        <div className="w-full">
                          <DatePickerFieldNew
                            control={control}
                            name="fromDate"
                            label="From Date"
                            disablePast={true}
                            inputFormat="dd-MM-yyyy"
                            inputRef={{
                              ...register("fromDate", {
                                onChange: (e) => {
                                  const parsedValue =
                                    parseInt(durationInDaysVal);
                                  if (!isNaN(parsedValue)) {
                                    const currentDate = e.target.value;
                                    const updatedDate = addDays(
                                      currentDate,
                                      parsedValue
                                    );
                                    setValue("toDate", updatedDate);
                                  }
                                },
                              }),
                            }}
                          />
                        </div>
                        <div className="w-full">
                          <DatePickerFieldNew
                            control={control}
                            name="toDate"
                            label="To Date"
                            disabled
                            inputFormat="dd-MM-yyyy"
                          />
                        </div>
                      </div>

                      <div className="flex gap-2 justify-end mb-2 mr-2">
                        <CommonButton
                          type="button"
                          className="border border-customRed text-customRed"
                          label="Clear All"
                          onClick={() => {
                            setDrugList([]);
                            setOrderedDrugList([]);
                            // setRowData(null)
                            reset(defaultValues);
                          }}
                        />

                        <CommonButton
                          type="button"
                          className="addButton bg-customBlue text-white"
                          label=" + Add"
                          onClick={() => {
                            orderDrugs();
                          }}
                        />
                      </div>
                    </fieldset>
                  </div>
                  <div className="flex space-x-2 justify-end gap-2 px-2"></div>
                </form>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      {openHighantiModal && (
        <Modal
          open={openHighantiModal}
          onClose={() => {
            setOpenHighantiModal(false);
            setCaptureHigherAntiReason(false);
            clearErrors("cultureReason");
            setValue("isCultureSent", false);
          }}
        >
          <Box
            className="w-full bg-white rounded-xl shadow-xl"
            sx={ModalStyleForHighantiModal}
          >
            <h6 className="text-lg font-semibold text-red-600 mb-4 text-center">
              *Please Check For Culture Sent
            </h6>
            {capturehigherAntiReason && (
              <div>
                <InputField
                  control={control}
                  name="cultureReason"
                  label={"Reason"}
                  error={errors.cultureReason}
                />
                <div className="flex justify-end mt-2">
                  <CommonButton
                    type="button"
                    label="Proceed"
                    className="bg-customGreen text-white"
                    onClick={() => {
                      if (getValues("cultureReason") === "") {
                        setError("cultureReason", {
                          type: "manual",
                          message: "cultureReason is required",
                        });
                      } else {
                        clearErrors("cultureReason");
                        setOpenHighantiModal(false);
                        setCaptureHigherAntiReason(false);
                      }
                    }}
                  />
                </div>
              </div>
            )}
            {!capturehigherAntiReason && (
              <div className="flex justify-end space-x-3 mt-2">
                <CommonButton
                  type="button"
                  label="No"
                  className="border border-customRed text-customRed"
                  onClick={() => setCaptureHigherAntiReason(true)}
                />
                <CommonButton
                  type="button"
                  label="Yes"
                  className="bg-customGreen text-white"
                  onClick={() => {
                    setOpenHighantiModal(false);
                    setCaptureHigherAntiReason(false);
                    setValue("isCultureSent", true);
                  }}
                />
              </div>
            )}
          </Box>
        </Modal>
      )}

      {openLoader && <CommonBackDrop openBackdrop={openLoader} />}

      <ConfirmationModal
        confirmationOpen={openConfiramtionModal}
        confirmationHandleClose={() => setOpenConfiramtionModal(false)}
        confirmationSubmitFunc={addRecord}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure want to add this record ?"
        confirmationButtonMsg="Add"
      />

      <ConfirmationModal
        confirmationOpen={openRateConfirmModal}
        confirmationHandleClose={() => {
          setOpenRateConfirmModal(false);
          setValue("drugName", null);
          setValue("drugName", null);
          setValue("genericName", null);
          setValue("form", null);
        }}
        confirmationSubmitFunc={() => {
          setOpenRateConfirmModal(false);
        }}
        confirmationLabel="Confirmation"
        confirmationMsg="High value Drug, please counsel relative !"
        confirmationButtonMsg="OK"
      />
    </>
  );
}
